// import React, { useEffect, useState } from "react";
// import styles from "./ManageProductionLine.module.css";
// import { useAuth } from "../../components/context/Auth";
// import { useLocation, useNavigate } from "react-router-dom";
// import TopTabBar from "../../components/updatedComponents/Tanolet/TopTabBar";
// import Button from "../../components/updatedComponents/Dealers/Button";
// import { TestTopAddDealerIcon } from "../../components/icons/Icon";
// import DealerStatusCard from "../../components/updatedComponents/Dealers/DealerStatusCard";
// import SearchBar from "../../components/updatedComponents/FormComponents/SearchBar";
// import NoDataFound from "../../components/updatedComponents/NoDataFound/NoDataFound";
// import { TemplateNotFound } from "../../components/icons/Icon2";
// import GoToPage from "../../components/updatedComponents/Pagnation/GoToPage";
// import DealerInfoCard from "../../components/updatedComponents/Dealers/DealerInfoCard";
// import Pagenation from "../../components/updatedComponents/Pagnation/Pagenation";
// import ProdLineInfoCard from "../../components/updatedComponents/Production/ProdLineInfoCard";
// import DropDown from "../../components/updatedComponents/FormComponents/DropDown";

// // ── Static seed data ───────────────────────────────────────────
// const STATIC_LINES = [
//   {
//     id: 1,
//     name: "Machine 1",
//     designation: ["WALLIKON", "UCLIP d11", "LCLIP d11"],
//     status: "running",
//     capacity: 600,
//     workingHour: 8,
//   },
//   {
//     id: 2,
//     name: "Extruder 2",
//     designation: ["Rajoo Engineers", "SHD11", "SHD12", "SHW1"],
//     status: "running",
//     capacity: 450,
//     workingHour: 10,
//   },
//   {
//     id: 3,
//     name: "Machine 3",
//     designation: ["WALLIKON", "SHF6", "SHF7"],
//     status: "idle",
//     capacity: 300,
//     workingHour: 8,
//   },
//   {
//     id: 4,
//     name: "Press Line 4",
//     designation: ["Kabra Extrusion", "CLB9", "CLB10"],
//     status: "maintenance",
//     capacity: 200,
//     workingHour: 6,
//   },
//   {
//     id: 5,
//     name: "Extruder 5",
//     designation: ["WALLIKON", "SHD13", "UCLIP d12"],
//     status: "stopped",
//     capacity: 520,
//     workingHour: 12,
//   },
//   {
//     id: 6,
//     name: "Assembly Line 6",
//     designation: ["Rajoo Engineers", "SHW2", "SHW3"],
//     status: "idle",
//     capacity: 380,
//     workingHour: 8,
//   },
//   {
//     id: 7,
//     name: "Blower Line 7",
//     designation: ["WALLIKON", "BLW1", "BLW2"],
//     status: "running",
//     capacity: 490,
//     workingHour: 8,
//   },
//   {
//     id: 8,
//     name: "Cutting Unit 8",
//     designation: ["Rajoo Engineers", "CUT4", "CUT5"],
//     status: "maintenance",
//     capacity: 150,
//     workingHour: 6,
//   },
// ];

// const STATUS_FILTERS = ["All", "Running", "Idle", "Maintenance", "Stopped"];

// const warehousesData = [
//   { _id: "1", warehousename: "Burlington", warehouseId: "BLTON01" },
//   { _id: "2", warehousename: "Golaganj", warehouseId: "GOGNJ01" },
//   { _id: "3", warehousename: "Nadarganj", warehouseId: "NDGNJ01" },
//   { _id: "4", warehousename: "Alambagh", warehouseId: "ALAMB0001" },
//   { _id: "5", warehousename: "Gomti Nagar", warehouseId: "GOMTI001" },
// ];

// const EMPTY_FORM = {
//   machineName: "",
//   manufacturer: "",
//   products: "",
//   capacity: "",
//   workingHour: "",
//   status: "Idle",
//   autoAssign: true,
//   pendingOnly: true,
// };

// // ── Main Component ─────────────────────────────────────────────
// const ManageProductionLine = () => {
//   const { mode } = useAuth();
//   const location = useLocation();
//   const navigate = useNavigate();

//   const [Isstatus, setIsstatus] = useState("All");
//   const [search, setSearch] = useState("");
//   const [page, setPage] = useState(1);
//   const [showDrawer, setShowDrawer] = useState(false);
//   const [selectedLine, setSelectedLine] = useState(null);
//   const [form, setForm] = useState(EMPTY_FORM);
//   const [warehouses, setWarehouses] = useState([]);
//   useEffect(() => {
//     if (warehousesData) {
//       setWarehouses(
//         warehousesData.map((w) => ({
//           label: w.warehousename,
//           value: w.warehouseId,
//         })),
//       );
//     }
//   }, []);

//   const PAGE_SIZE = 24;

//   // ── Filter ─────────────────────────────────────────────────
//   const filtered = STATIC_LINES.filter((l) => {
//     const matchStatus =
//       Isstatus === "All" || l.status === Isstatus.toLowerCase();
//     const q = search.toLowerCase();
//     const matchSearch =
//       !q ||
//       l.name.toLowerCase().includes(q) ||
//       l.designation.some((d) => d.toLowerCase().includes(q));
//     return matchStatus && matchSearch;
//   });

//   const totalPages = Math.max(1, Math.ceil(filtered.length / PAGE_SIZE));
//   const paginated = filtered.slice((page - 1) * PAGE_SIZE, page * PAGE_SIZE);

//   // status counts matching mangerStatusData shape exactly
//   const lineStatusData = STATUS_FILTERS.map((s) => ({
//     statusText: s,
//     statusItemCount:
//       s === "All"
//         ? STATIC_LINES.length
//         : STATIC_LINES.filter((l) => l.status === s.toLowerCase()).length,
//   }));

//   // ── Drawer helpers ─────────────────────────────────────────
//   const openCreate = () => {
//     setSelectedLine(null);
//     setForm(EMPTY_FORM);
//     setShowDrawer(true);
//   };

//   const openEdit = (line) => {
//     setSelectedLine(line);
//     setForm({
//       machineName: line.name,
//       manufacturer: line.designation[0] || "",
//       products: line.designation.slice(1).join(", "),
//       capacity: line.capacity,
//       workingHour: line.workingHour,
//       status: line.status.charAt(0).toUpperCase() + line.status.slice(1),
//       autoAssign: true,
//       pendingOnly: true,
//     });
//     setShowDrawer(true);
//   };

//   const handleFormChange = (field, value) =>
//     setForm((prev) => ({ ...prev, [field]: value }));

//   const handleStatusChange = (s) => {
//     setIsstatus(s);
//     setPage(1);
//   };

//   return (
//     <>
//       {/* ── Drawer ─────────────────────────────────────────── */}
//       {showDrawer && (
//         <div
//           className={styles.drawerOverlay}
//           onClick={() => setShowDrawer(false)}
//         >
//           <div
//             className={`${styles.drawer} ${mode ? styles.drawer_dark : ""}`}
//             onClick={(e) => e.stopPropagation()}
//           >
//             <div
//               className={`${styles.drawerHeader} ${
//                 mode ? styles.drawerHeader_dark : ""
//               }`}
//             >
//               <h2
//                 className={`${styles.drawerTitle} ${mode ? styles.drawerTitle_dark : ""}`}
//               >
//                 {selectedLine
//                   ? "Update Production Line"
//                   : "Add Production Line"}
//               </h2>
//               <button
//                 className={styles.closeBtn}
//                 onClick={() => setShowDrawer(false)}
//               >
//                 ✕
//               </button>
//             </div>

//             <div className={styles.drawerBody}>
//               <div className={styles.formRow}>
//                 <div className={styles.formGroup}>
//                   <label
//                     className={`${styles.formLabel} ${mode ? styles.formLabel_dark : ""}`}
//                   >
//                     Machine Name
//                   </label>
//                   <input
//                     className={`${styles.formInput} ${mode ? styles.formInput_dark : ""}`}
//                     type="text"
//                     value={form.machineName}
//                     onChange={(e) =>
//                       handleFormChange("machineName", e.target.value)
//                     }
//                     placeholder="e.g. Extruder 2"
//                   />
//                 </div>
//                 <div className={styles.formGroup}>
//                   <label
//                     className={`${styles.formLabel} ${mode ? styles.formLabel_dark : ""}`}
//                   >
//                     Manufacturer
//                   </label>
//                   <input
//                     className={`${styles.formInput} ${mode ? styles.formInput_dark : ""}`}
//                     type="text"
//                     value={form.manufacturer}
//                     onChange={(e) =>
//                       handleFormChange("manufacturer", e.target.value)
//                     }
//                     placeholder="e.g. WALLIKON"
//                   />
//                 </div>
//               </div>

//               <div className={styles.formGroup}>
//                 <label
//                   className={`${styles.formLabel} ${mode ? styles.formLabel_dark : ""}`}
//                 >
//                   Products (comma-separated)
//                 </label>
//                 <textarea
//                   className={`${styles.formTextarea} ${mode ? styles.formInput_dark : ""}`}
//                   rows={3}
//                   value={form.products}
//                   onChange={(e) => handleFormChange("products", e.target.value)}
//                   placeholder="UCLIP d11, LCLIP d11"
//                 />
//               </div>

//               <div className={styles.formRow}>
//                 <div className={styles.formGroup}>
//                   <label
//                     className={`${styles.formLabel} ${mode ? styles.formLabel_dark : ""}`}
//                   >
//                     Capacity (pcs/day)
//                   </label>
//                   <input
//                     className={`${styles.formInput} ${mode ? styles.formInput_dark : ""}`}
//                     type="number"
//                     value={form.capacity}
//                     onChange={(e) =>
//                       handleFormChange("capacity", e.target.value)
//                     }
//                     placeholder="600"
//                   />
//                 </div>
//                 <div className={styles.formGroup}>
//                   <label
//                     className={`${styles.formLabel} ${mode ? styles.formLabel_dark : ""}`}
//                   >
//                     Working Hours / Day
//                   </label>
//                   <input
//                     className={`${styles.formInput} ${mode ? styles.formInput_dark : ""}`}
//                     type="number"
//                     value={form.workingHour}
//                     onChange={(e) =>
//                       handleFormChange("workingHour", e.target.value)
//                     }
//                     placeholder="8"
//                   />
//                 </div>
//               </div>

//               <div className={styles.formGroup}>
//                 <label
//                   className={`${styles.formLabel} ${mode ? styles.formLabel_dark : ""}`}
//                 >
//                   Status
//                 </label>
//                 <select
//                   className={`${styles.formSelect} ${mode ? styles.formInput_dark : ""}`}
//                   value={form.status}
//                   onChange={(e) => handleFormChange("status", e.target.value)}
//                 >
//                   <option value="Running">Running</option>
//                   <option value="Idle">Idle</option>
//                   <option value="Maintenance">Maintenance</option>
//                   <option value="Stopped">Stopped</option>
//                 </select>
//               </div>

//               <div
//                 className={`${styles.settingsBox} ${mode ? styles.settingsBox_dark : ""}`}
//               >
//                 <p
//                   className={`${styles.settingsTitle} ${mode ? styles.settingsTitle_dark : ""}`}
//                 >
//                   Settings
//                 </p>
//                 <div className={styles.settingRow}>
//                   <span
//                     className={`${styles.settingLabel} ${mode ? styles.settingLabel_dark : ""}`}
//                   >
//                     Auto-assign selected products to this line
//                   </span>
//                   <label className={styles.toggle}>
//                     <input
//                       type="checkbox"
//                       checked={form.autoAssign}
//                       onChange={(e) =>
//                         handleFormChange("autoAssign", e.target.checked)
//                       }
//                     />
//                     <span className={styles.toggleSlider} />
//                   </label>
//                 </div>
//                 <div className={styles.settingRow}>
//                   <span
//                     className={`${styles.settingLabel} ${mode ? styles.settingLabel_dark : ""}`}
//                   >
//                     Show only pending items in machine view
//                   </span>
//                   <label className={styles.toggle}>
//                     <input
//                       type="checkbox"
//                       checked={form.pendingOnly}
//                       onChange={(e) =>
//                         handleFormChange("pendingOnly", e.target.checked)
//                       }
//                     />
//                     <span className={styles.toggleSlider} />
//                   </label>
//                 </div>
//               </div>
//             </div>

//             <div
//               className={`${styles.drawerFooter} ${mode ? styles.drawerFooter_dark : ""}`}
//             >
//               <button
//                 className={styles.cancelBtn}
//                 onClick={() => setShowDrawer(false)}
//               >
//                 Cancel
//               </button>
//               <button className={styles.saveBtn}>
//                 {selectedLine ? "Update Line" : "Create Line"}
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* ── Page shell ─────────────────────────────────────── */}
//       <div
//         className={styles.mgx}
//         style={
//           mode ? { backgroundColor: "#2C2E33", borderColor: "#2C2E33" } : {}
//         }
//       >
//         {/* Top bar — identical to Managers */}
//         <div className={styles.mgx_top}>
//           <TopTabBar
//             text={location.pathname.slice(1, location.pathname.length)}
//           />
//           <div className={styles.mgx_top_right}>
//             <Button
//               buttonIcon={<TestTopAddDealerIcon />}
//               buttonText={"Add Line"}
//               buttonBgColor={"#4164E3"}
//               buttonTextColor={"#ffffff"}
//               buttonBorder={"none"}
//               buttonClick={openCreate}
//             />
//           </div>
//         </div>

//         {/* Status filter strip — same receipts_filter + DealerStatusCard */}
//         <div
//           className={styles.mgx_middle}
//           style={
//             mode ? { backgroundColor: "#232529", borderColor: "#232529" } : {}
//           }
//         >
//           {lineStatusData.map((status) => (
//             <div
//               key={status.statusText}
//               className={`${styles.receipts_filter} ${
//                 mode ? styles.receipts_filter_dark : ""
//               } ${
//                 status.statusText === Isstatus
//                   ? mode
//                     ? styles.receipts_filter_active_dark
//                     : styles.receipts_filter_active
//                   : ""
//               }`}
//               onClick={() => handleStatusChange(status.statusText)}
//             >
//               <DealerStatusCard
//                 statusText={status.statusText}
//                 statusItemCount={status.statusItemCount}
//               />
//             </div>
//           ))}
//         </div>

//         {/* Bottom — search + grid */}
//         <div
//           className={styles.mgx_bottom}
//           style={mode ? { backgroundColor: "#2C2E33" } : {}}
//         >
//           <div className={styles.mgx_top} style={{ marginBottom: "10px" }}>
//             {/* Same SearchBar component as Managers */}
//             <div>
//               <SearchBar
//                 padding={"6px"}
//                 fontSize={"12px"}
//                 fontWeight={"400"}
//                 borderRadius={"5px"}
//                 placeholder={"Search Production Lines"}
//                 onChange={(e) => {
//                   setSearch(e.target.value);
//                   setPage(1);
//                 }}
//               />
//             </div>
//             <div className={styles.mgx_top_right}>
//               {/* future filters slot */}
//               <DropDown
//                 label={"Warehouse"}
//                 listLabel={"All"}
//                 options={warehouses}
//                 onSelect={(option) =>
//                   // production(setFilter({ selectedWarehouseId: option.value }))
//                   console.log(option)
//                 }
//                 // onReject={() =>
//                 // production(setFilter({ selectedWarehouseId: null }))

//                 // }
//               />
//             </div>
//           </div>

//           {paginated.length === 0 ? (
//             <>
//               <div
//                 style={{
//                   flex: 1,
//                   display: "flex",
//                   flexDirection: "column",
//                   justifyContent: "center",
//                   alignItems: "center",
//                 }}
//               >
//                 <NoDataFound
//                   icon={<TemplateNotFound />}
//                   to={"/production/line"}
//                 />

//                 <p style={{ color: mode ? "#ffffff" : "#000000" }}>
//                   No Data Found
//                 </p>
//               </div>
//             </>
//           ) : (
//             <div className={styles.maindivscroll}>
//               <div
//                 className={styles.mgx_data}
//                 style={mode ? { backgroundColor: "#2C2E33" } : {}}
//               >
//                 {paginated.map((line) => (
//                   <div
//                     className={styles.mgx_card}
//                     key={line.id}
//                     onClick={() => openEdit(line)}
//                   >
//                     <ProdLineInfoCard
//                       lineName={line.name}
//                       lineStatus={line.status}
//                       manufacturer={line.designation[0]}
//                       subText={line.designation.slice(1).join(", ")}
//                       capacity={line.capacity}
//                       workingHour={line.workingHour}
//                     />
//                   </div>
//                 ))}
//               </div>
//             </div>
//           )}
//         </div>

//         {/* Pagination — same GoToPage + Pagenation as Managers */}
//         <div
//           className={styles.mgx_pagination}
//           style={{ backgroundColor: mode ? "#232529" : "#fff" }}
//         >
//           <div style={{ width: "50%" }}>
//             <div
//               style={{
//                 width: "50%",
//                 display: "flex",
//                 justifyContent: "flex-start",
//                 fontSize: "14px",
//               }}
//             >
//               <GoToPage
//                 currentPage={page}
//                 setCurrentPage={(num) => setPage(num)}
//                 totalPages={totalPages}
//                 key={"1"}
//               />
//             </div>
//           </div>
//           <div
//             style={{
//               width: "50%",
//               display: "flex",
//               justifyContent: "flex-end",
//               fontSize: "12px",
//             }}
//           >
//             <Pagenation
//               currentPage={page}
//               setCurrentPage={(num) => setPage(num)}
//               totalPages={totalPages}
//               key={"1"}
//             />
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default ManageProductionLine;

// import React, { useEffect, useState } from "react";
// import styles from "./ManageProductionLine.module.css";
// import { useAuth } from "../../components/context/Auth";
// import { useLocation } from "react-router-dom";
// import TopTabBar from "../../components/updatedComponents/Tanolet/TopTabBar";
// import Button from "../../components/updatedComponents/Dealers/Button";
// import { TestTopAddDealerIcon } from "../../components/icons/Icon";
// import DealerStatusCard from "../../components/updatedComponents/Dealers/DealerStatusCard";
// import SearchBar from "../../components/updatedComponents/FormComponents/SearchBar";
// import NoDataFound from "../../components/updatedComponents/NoDataFound/NoDataFound";
// import { TemplateNotFound } from "../../components/icons/Icon2";
// import GoToPage from "../../components/updatedComponents/Pagnation/GoToPage";
// import Pagenation from "../../components/updatedComponents/Pagnation/Pagenation";
// import ProdLineInfoCard from "../../components/updatedComponents/Production/ProdLineInfoCard";
// import DropDown from "../../components/updatedComponents/FormComponents/DropDown";

// const STATIC_LINES = [
//   {
//     id: 1,
//     name: "Machine 1",
//     designation: ["WALLIKON", "UCLIP d11", "LCLIP d11"],
//     status: "running",
//     capacity: 600,
//     workingHour: 8,
//   },
//   {
//     id: 2,
//     name: "Extruder 2",
//     designation: ["Rajoo Engineers", "SHD11", "SHD12", "SHW1"],
//     status: "running",
//     capacity: 450,
//     workingHour: 10,
//   },
//   {
//     id: 3,
//     name: "Machine 3",
//     designation: ["WALLIKON", "SHF6", "SHF7"],
//     status: "idle",
//     capacity: 300,
//     workingHour: 8,
//   },
//   {
//     id: 4,
//     name: "Press Line 4",
//     designation: ["Kabra Extrusion", "CLB9", "CLB10"],
//     status: "maintenance",
//     capacity: 200,
//     workingHour: 6,
//   },
//   {
//     id: 5,
//     name: "Extruder 5",
//     designation: ["WALLIKON", "SHD13", "UCLIP d12"],
//     status: "stopped",
//     capacity: 520,
//     workingHour: 12,
//   },
//   {
//     id: 6,
//     name: "Assembly Line 6",
//     designation: ["Rajoo Engineers", "SHW2", "SHW3"],
//     status: "idle",
//     capacity: 380,
//     workingHour: 8,
//   },
//   {
//     id: 7,
//     name: "Blower Line 7",
//     designation: ["WALLIKON", "BLW1", "BLW2"],
//     status: "running",
//     capacity: 490,
//     workingHour: 8,
//   },
//   {
//     id: 8,
//     name: "Cutting Unit 8",
//     designation: ["Rajoo Engineers", "CUT4", "CUT5"],
//     status: "maintenance",
//     capacity: 150,
//     workingHour: 6,
//   },
// ];

// const STATUS_FILTERS = ["All", "Running", "Idle", "Maintenance", "Stopped"];

// const warehousesData = [
//   { _id: "1", warehousename: "Burlington", warehouseId: "BLTON01" },
//   { _id: "2", warehousename: "Golaganj", warehouseId: "GOGNJ01" },
//   { _id: "3", warehousename: "Nadarganj", warehouseId: "NDGNJ01" },
//   { _id: "4", warehousename: "Alambagh", warehouseId: "ALAMB0001" },
//   { _id: "5", warehousename: "Gomti Nagar", warehouseId: "GOMTI001" },
// ];

// const EMPTY_FORM = {
//   machineName: "",
//   manufacturer: "",
//   products: "",
//   capacity: "",
//   workingHour: "",
//   status: "Idle",
//   autoAssign: true,
//   pendingOnly: true,
// };

// const ManageProductionLine = () => {
//   const { mode } = useAuth();
//   const location = useLocation();

//   const [Isstatus, setIsstatus] = useState("All");
//   const [search, setSearch] = useState("");
//   const [page, setPage] = useState(1);
//   const [showDrawer, setShowDrawer] = useState(false);
//   const [selectedLine, setSelectedLine] = useState(null);
//   const [form, setForm] = useState(EMPTY_FORM);
//   const [warehouses, setWarehouses] = useState([]);

//   useEffect(() => {
//     if (warehousesData) {
//       setWarehouses(
//         warehousesData.map((w) => ({
//           label: w.warehousename,
//           value: w.warehouseId,
//         })),
//       );
//     }
//   }, []);

//   const PAGE_SIZE = 24;

//   const filtered = STATIC_LINES.filter((l) => {
//     const matchStatus =
//       Isstatus === "All" || l.status === Isstatus.toLowerCase();
//     const q = search.toLowerCase();
//     const matchSearch =
//       !q ||
//       l.name.toLowerCase().includes(q) ||
//       l.designation.some((d) => d.toLowerCase().includes(q));
//     return matchStatus && matchSearch;
//   });

//   const totalPages = Math.max(1, Math.ceil(filtered.length / PAGE_SIZE));
//   const paginated = filtered.slice((page - 1) * PAGE_SIZE, page * PAGE_SIZE);

//   const lineStatusData = STATUS_FILTERS.map((s) => ({
//     statusText: s,
//     statusItemCount:
//       s === "All"
//         ? STATIC_LINES.length
//         : STATIC_LINES.filter((l) => l.status === s.toLowerCase()).length,
//   }));

//   const openCreate = () => {
//     setSelectedLine(null);
//     setForm(EMPTY_FORM);
//     setShowDrawer(true);
//   };

//   const openEdit = (line) => {
//     setSelectedLine(line);
//     setForm({
//       machineName: line.name,
//       manufacturer: line.designation[0] || "",
//       products: line.designation.slice(1).join(", "),
//       capacity: line.capacity,
//       workingHour: line.workingHour,
//       status: line.status.charAt(0).toUpperCase() + line.status.slice(1),
//       autoAssign: true,
//       pendingOnly: true,
//     });
//     setShowDrawer(true);
//   };

//   const handleFormChange = (field, value) =>
//     setForm((prev) => ({ ...prev, [field]: value }));

//   const handleStatusChange = (s) => {
//     setIsstatus(s);
//     setPage(1);
//   };

//   const handleQuickStatus = (s) => handleFormChange("status", s);

//   return (
//     <>
//       {/* ── Drawer ───────────────────────────────────────────────── */}
//       {showDrawer && (
//         <div
//           className={styles.modalOverlay}
//           onClick={() => setShowDrawer(false)}
//         >
//           <div
//             className={`${styles.updateDrawer} ${mode ? styles.updateDrawerDark : ""}`}
//             onClick={(e) => e.stopPropagation()}
//           >
//             {/* Header */}
//             <div className={styles.drawerHeader}>
//               <h2>
//                 {selectedLine
//                   ? "Update Production Line"
//                   : "Add Production Line"}
//               </h2>
//               <button onClick={() => setShowDrawer(false)}>✕</button>
//             </div>

//             {/* Body */}
//             <div className={styles.drawerBody}>
//               {/* Info cards — shown only in edit mode */}
//               {selectedLine && (
//                 <div className={styles.infoGrid}>
//                   <div
//                     className={`${styles.infoCard} ${mode ? styles.infoCardDark : ""}`}
//                   >
//                     <span>Capacity</span>
//                     <strong>{selectedLine.capacity}</strong>
//                     <div className={styles.infoSub}>pcs / day</div>
//                   </div>
//                   <div
//                     className={`${styles.infoCard} ${mode ? styles.infoCardDark : ""}`}
//                   >
//                     <span>Working Hours</span>
//                     <strong>{selectedLine.workingHour}</strong>
//                     <div className={styles.infoSub}>hrs / day</div>
//                   </div>
//                 </div>
//               )}

//               {/* Machine Name + Manufacturer */}
//               <div className={styles.formRow}>
//                 <div className={styles.formGroup}>
//                   <label className={mode ? styles.labelDark : ""}>
//                     Machine Name
//                   </label>
//                   <input
//                     type="text"
//                     value={form.machineName}
//                     onChange={(e) =>
//                       handleFormChange("machineName", e.target.value)
//                     }
//                     placeholder="e.g. Extruder 2"
//                     className={mode ? styles.inputDark : ""}
//                   />
//                 </div>
//                 <div className={styles.formGroup}>
//                   <label className={mode ? styles.labelDark : ""}>
//                     Manufacturer
//                   </label>
//                   <input
//                     type="text"
//                     value={form.manufacturer}
//                     onChange={(e) =>
//                       handleFormChange("manufacturer", e.target.value)
//                     }
//                     placeholder="e.g. WALLIKON"
//                     className={mode ? styles.inputDark : ""}
//                   />
//                 </div>
//               </div>

//               {/* Products */}
//               <div className={styles.formGroup}>
//                 <label className={mode ? styles.labelDark : ""}>
//                   Products (comma-separated)
//                 </label>
//                 <textarea
//                   value={form.products}
//                   onChange={(e) => handleFormChange("products", e.target.value)}
//                   placeholder="UCLIP d11, LCLIP d11"
//                   className={mode ? styles.inputDark : ""}
//                 />
//               </div>

//               {/* Capacity + Working Hours */}
//               <div className={styles.formRow}>
//                 <div className={styles.formGroup}>
//                   <label className={mode ? styles.labelDark : ""}>
//                     Capacity (pcs/day)
//                   </label>
//                   <input
//                     type="number"
//                     value={form.capacity}
//                     onChange={(e) =>
//                       handleFormChange("capacity", e.target.value)
//                     }
//                     placeholder="600"
//                     className={mode ? styles.inputDark : ""}
//                   />
//                 </div>
//                 <div className={styles.formGroup}>
//                   <label className={mode ? styles.labelDark : ""}>
//                     Working Hours / Day
//                   </label>
//                   <input
//                     type="number"
//                     value={form.workingHour}
//                     onChange={(e) =>
//                       handleFormChange("workingHour", e.target.value)
//                     }
//                     placeholder="8"
//                     className={mode ? styles.inputDark : ""}
//                   />
//                 </div>
//               </div>

//               {/* Status */}
//               <div className={styles.formGroup}>
//                 <label className={mode ? styles.labelDark : ""}>Status</label>
//                 <select
//                   value={form.status}
//                   onChange={(e) => handleFormChange("status", e.target.value)}
//                   className={mode ? styles.inputDark : ""}
//                 >
//                   <option>Running</option>
//                   <option>Idle</option>
//                   <option>Maintenance</option>
//                   <option>Stopped</option>
//                 </select>
//               </div>

//               {/* Quick status buttons — edit mode only */}
//               {/* {selectedLine && (
//                 <div className={styles.quickBtns}>
//                   {["Running", "Idle", "Maintenance","Stopped"].map((s) => (
//                     <button
//                       key={s}
//                       className={`${styles.quickBtn} ${mode ? styles.quickBtnDark : ""}`}
//                       onClick={() => handleQuickStatus(s)}
//                     >
//                       {s}
//                     </button>
//                   ))}
//                 </div>
//               )} */}

//               {/* Settings */}
//               <div
//                 className={`${styles.settingsBox} ${mode ? styles.settingsBoxDark : ""}`}
//               >
//                 <p
//                   className={`${styles.settingsTitle} ${mode ? styles.settingsTitleDark : ""}`}
//                 >
//                   Settings
//                 </p>
//                 <div className={styles.settingRow}>
//                   <span
//                     className={`${styles.settingLabel} ${mode ? styles.settingLabelDark : ""}`}
//                   >
//                     Auto-assign selected products to this line
//                   </span>
//                   <label className={styles.toggle}>
//                     <input
//                       type="checkbox"
//                       checked={form.autoAssign}
//                       onChange={(e) =>
//                         handleFormChange("autoAssign", e.target.checked)
//                       }
//                     />
//                     <span className={styles.toggleSlider} />
//                   </label>
//                 </div>
//                 <div className={styles.settingRow}>
//                   <span
//                     className={`${styles.settingLabel} ${mode ? styles.settingLabelDark : ""}`}
//                   >
//                     Show only pending items in machine view
//                   </span>
//                   <label className={styles.toggle}>
//                     <input
//                       type="checkbox"
//                       checked={form.pendingOnly}
//                       onChange={(e) =>
//                         handleFormChange("pendingOnly", e.target.checked)
//                       }
//                     />
//                     <span className={styles.toggleSlider} />
//                   </label>
//                 </div>
//               </div>
//             </div>

//             {/* Footer */}
//             <div
//               className={`${styles.drawerFooter} ${mode ? styles.drawerFooterDark : ""}`}
//             >
//               <Button
//                 buttonTextColor={"#ffffff"}
//                 buttonBgColor={"#000000"}
//                 buttonClick={() => setShowDrawer(false)}
//                 buttonText={"Cancel"}
//               />
//               <Button
//                 buttonTextColor={"#ffffff"}
//                 buttonBgColor={"#4164E3"}
//                 buttonText={selectedLine ? "Update Line" : "Create Line"}
//               />
//             </div>
//           </div>
//         </div>
//       )}

//       {/* ── Page Shell ──────────────────────────────────────────── */}
//       <div
//         className={styles.mgx}
//         style={
//           mode ? { backgroundColor: "#2C2E33", borderColor: "#2C2E33" } : {}
//         }
//       >
//         {/* Top bar */}
//         <div className={styles.mgx_top}>
//           <TopTabBar text={location.pathname.slice(1)} />
//           <div className={styles.mgx_top_right}>
//             <Button
//               buttonIcon={<TestTopAddDealerIcon />}
//               buttonText={"Add Line"}
//               buttonBgColor={"#4164E3"}
//               buttonTextColor={"#ffffff"}
//               buttonBorder={"none"}
//               buttonClick={openCreate}
//             />
//           </div>
//         </div>

//         {/* Status filter strip */}
//         <div
//           className={styles.mgx_middle}
//           style={
//             mode ? { backgroundColor: "#232529", borderColor: "#232529" } : {}
//           }
//         >
//           {lineStatusData.map((status) => (
//             <div
//               key={status.statusText}
//               className={`${styles.receipts_filter} ${mode ? styles.receipts_filter_dark : ""} ${
//                 status.statusText === Isstatus
//                   ? mode
//                     ? styles.receipts_filter_active_dark
//                     : styles.receipts_filter_active
//                   : ""
//               }`}
//               onClick={() => handleStatusChange(status.statusText)}
//             >
//               <DealerStatusCard
//                 statusText={status.statusText}
//                 statusItemCount={status.statusItemCount}
//               />
//             </div>
//           ))}
//         </div>

//         {/* Bottom — search + grid */}
//         <div
//           className={styles.mgx_bottom}
//           style={mode ? { backgroundColor: "#2C2E33" } : {}}
//         >
//           <div className={styles.mgx_top} style={{ marginBottom: "10px" }}>
//             <SearchBar
//               padding={"6px"}
//               fontSize={"12px"}
//               fontWeight={"400"}
//               borderRadius={"5px"}
//               placeholder={"Search Production Lines"}
//               onChange={(e) => {
//                 setSearch(e.target.value);
//                 setPage(1);
//               }}
//             />
//             <div className={styles.mgx_top_right}>
//               <DropDown
//                 label={"Warehouse"}
//                 listLabel={"All"}
//                 options={warehouses}
//                 onSelect={(option) => console.log(option)}
//               />
//             </div>
//           </div>

//           {paginated.length === 0 ? (
//             <div
//               style={{
//                 flex: 1,
//                 display: "flex",
//                 flexDirection: "column",
//                 justifyContent: "center",
//                 alignItems: "center",
//               }}
//             >
//               <NoDataFound
//                 icon={<TemplateNotFound />}
//                 to={"/production/line"}
//               />
//               <p style={{ color: mode ? "#ffffff" : "#000000" }}>
//                 No Data Found
//               </p>
//             </div>
//           ) : (
//             <div className={styles.maindivscroll}>
//               <div
//                 className={styles.mgx_data}
//                 style={mode ? { backgroundColor: "#2C2E33" } : {}}
//               >
//                 {paginated.map((line) => (
//                   <div
//                     className={styles.mgx_card}
//                     key={line.id}
//                     onClick={() => openEdit(line)}
//                   >
//                     <ProdLineInfoCard
//                       lineName={line.name}
//                       lineStatus={line.status}
//                       manufacturer={line.designation[0]}
//                       subText={line.designation.slice(1).join(", ")}
//                       capacity={line.capacity}
//                       workingHour={line.workingHour}
//                     />
//                   </div>
//                 ))}
//               </div>
//             </div>
//           )}
//         </div>

//         {/* Pagination */}
//         <div
//           className={styles.mgx_pagination}
//           style={{ backgroundColor: mode ? "#232529" : "#fff" }}
//         >
//           <div style={{ width: "50%" }}>
//             <div
//               style={{
//                 width: "50%",
//                 display: "flex",
//                 justifyContent: "flex-start",
//                 fontSize: "14px",
//               }}
//             >
//               <GoToPage
//                 currentPage={page}
//                 setCurrentPage={(n) => setPage(n)}
//                 totalPages={totalPages}
//                 key="goto"
//               />
//             </div>
//           </div>
//           <div
//             style={{
//               width: "50%",
//               display: "flex",
//               justifyContent: "flex-end",
//               fontSize: "12px",
//             }}
//           >
//             <Pagenation
//               currentPage={page}
//               setCurrentPage={(n) => setPage(n)}
//               totalPages={totalPages}
//               key="page"
//             />
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default ManageProductionLine;

import React, { useEffect, useState, useCallback, useRef } from "react";
import styles from "./ManageProductionLine.module.css";
import { useAuth } from "../../components/context/Auth";
import { useLocation } from "react-router-dom";
import TopTabBar from "../../components/updatedComponents/Tanolet/TopTabBar";
import Button from "../../components/updatedComponents/Dealers/Button";
import { TestTopAddDealerIcon } from "../../components/icons/Icon";
import DealerStatusCard from "../../components/updatedComponents/Dealers/DealerStatusCard";
import SearchBar from "../../components/updatedComponents/FormComponents/SearchBar";
import NoDataFound from "../../components/updatedComponents/NoDataFound/NoDataFound";
import { TemplateNotFound } from "../../components/icons/Icon2";
import GoToPage from "../../components/updatedComponents/Pagnation/GoToPage";
import Pagenation from "../../components/updatedComponents/Pagnation/Pagenation";
import ProdLineInfoCard from "../../components/updatedComponents/Production/ProdLineInfoCard";
import DropDown from "../../components/updatedComponents/FormComponents/DropDown";
import fetchData from "../../APIsControll/apiControll";

const STATIC_LINES = [
  {
    id: 1,
    name: "Machine 1",
    designation: ["WALLIKON", "UCLIP d11", "LCLIP d11"],
    status: "running",
    capacity: 600,
    workingHour: 8,
    warehouse: "Burlington",
    warehouseId: "BLTON01",
  },
  {
    id: 2,
    name: "Extruder 2",
    designation: ["Rajoo Engineers", "SHD11", "SHD12", "SHW1"],
    status: "running",
    capacity: 450,
    workingHour: 10,
    warehouse: "Golaganj",
    warehouseId: "GOGNJ01",
  },
  {
    id: 3,
    name: "Machine 3",
    designation: ["WALLIKON", "SHF6", "SHF7"],
    status: "idle",
    capacity: 300,
    workingHour: 8,
    warehouse: "Nadarganj",
    warehouseId: "NDGNJ01",
  },
  {
    id: 4,
    name: "Press Line 4",
    designation: ["Kabra Extrusion", "CLB9", "CLB10"],
    status: "maintenance",
    capacity: 200,
    workingHour: 6,
    warehouse: "Alambagh",
    warehouseId: "ALAMB0001",
  },
  {
    id: 5,
    name: "Extruder 5",
    designation: ["WALLIKON", "SHD13", "UCLIP d12"],
    status: "stopped",
    capacity: 520,
    workingHour: 12,
    warehouse: "Gomti Nagar",
    warehouseId: "GOMTI001",
  },
  {
    id: 6,
    name: "Assembly Line 6",
    designation: ["Rajoo Engineers", "SHW2", "SHW3"],
    status: "idle",
    capacity: 380,
    workingHour: 8,
    warehouse: "Alambagh",
    warehouseId: "ALAMB0001",
  },
  {
    id: 7,
    name: "Blower Line 7",
    designation: ["WALLIKON", "BLW1", "BLW2"],
    status: "running",
    capacity: 490,
    workingHour: 8,
    warehouse: "Nadarganj",
    warehouseId: "NDGNJ01",
  },
  {
    id: 8,
    name: "Cutting Unit 8",
    designation: ["Rajoo Engineers", "CUT4", "CUT5"],
    status: "maintenance",
    capacity: 150,
    workingHour: 6,
    warehouse: "Golaganj",
    warehouseId: "GOGNJ01",
  },
];

const STATUS_FILTERS = ["All", "Running", "Idle", "Maintenance", "Stopped"];

const warehousesData = [
  { _id: "1", warehouse: "Burlington", warehouseId: "BLTON01" },
  { _id: "2", warehouse: "Golaganj", warehouseId: "GOGNJ01" },
  { _id: "3", warehouse: "Nadarganj", warehouseId: "NDGNJ01" },
  { _id: "4", warehouse: "Alambagh", warehouseId: "ALAMB0001" },
  { _id: "5", warehouse: "Gomti Nagar", warehouseId: "GOMTI001" },
];

const EMPTY_FORM = {
  machineName: "",
  machineId: "",
  modelNo: "",
  warehouse: "",
  capacity: "",
  workingHour: "",
  status: "Idle",
  autoAssign: true,
  pendingOnly: true,
};

/* ─── Item Search Hook ──────────────────────────────────────── */
function useItemSearch(warehouseId) {
  const [keyword, setKeyword] = useState("");
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);

  const fetchItems = useCallback(async (kw) => {
    if (!kw.trim()) {
      setResults([]);
      return;
    }
    const apiData = {
      managerId: 1,
      keyword: kw,
      // selectedWarehouse:[warehouseId]
    };
    try {
      setLoading(true);
      const result = await fetchData("order/searchitems?page=", apiData);
      // if (result.status === "success") {
      //   setResults(result.data || []);
      //   setCurrentIndex(0);
      // }
      if (result.status === "success") {
        const filteredItems = (result.data || []).filter(
          (item) =>
            String(item.warehouseId).trim() === String(warehouseId).trim(),
        );
        setResults(filteredItems);
        setCurrentIndex(0);
      }
    } catch {
      setResults([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    const t = setTimeout(() => {
      fetchItems(keyword);
    }, 300);

    return () => clearTimeout(t);
  }, [keyword, warehouseId, fetchItems]);

  return {
    keyword,
    setKeyword,
    results,
    setResults,
    loading,
    currentIndex,
    setCurrentIndex,
  };
}

/* ─── Item Chip Search Component ───────────────────────────── */
function ItemChipSearch({ mode, selectedItems, onAdd, onRemove, warehouseId }) {
  const {
    keyword,
    setKeyword,
    results,
    setResults,
    loading,
    currentIndex,
    setCurrentIndex,
  } = useItemSearch(warehouseId);
  const inputRef = useRef(null);
  const rowRefs = useRef([]);
  const [open, setOpen] = useState(false);

  const handleKey = (e) => {
    if (!open || results.length === 0) return;
    if (e.key === "ArrowDown") {
      e.preventDefault();
      setCurrentIndex((i) => Math.min(i + 1, results.length - 1));
    } else if (e.key === "ArrowUp") {
      e.preventDefault();
      setCurrentIndex((i) => Math.max(i - 1, 0));
    } else if (e.key === "Enter") {
      e.preventDefault();
      const item = results[currentIndex];
      if (item) handleSelect(item);
    } else if (e.key === "Escape") {
      setOpen(false);
    }
  };

  const handleSelect = (item) => {
    const alreadyAdded = selectedItems.some(
      (s) => s.itemNo === item.itemNo && s.warehouseId === item.warehouseId,
    );
    if (!alreadyAdded) onAdd(item);
    setKeyword("");
    setResults([]);
    setOpen(false);
    inputRef.current?.focus();
  };

  useEffect(() => {
    setOpen(results.length > 0 && keyword.trim().length > 0);
  }, [results.length, keyword]);

  useEffect(() => {
    if (rowRefs.current[currentIndex]) {
      rowRefs.current[currentIndex].scrollIntoView({ block: "nearest" });
    }
  }, [currentIndex]);

  return (
    <div className={styles.formGroup}>
      <label className={mode ? styles.labelDark : ""}>Products / Items</label>

      {/* ── Chips ── */}
      {selectedItems.length > 0 && (
        <div
          className={`${styles.chipContainer} ${mode ? styles.chipContainerDark : ""}`}
        >
          {selectedItems.map((item, i) => (
            <span
              key={`${item.itemNo}-${item.warehouseId || i}`}
              className={`${styles.chip} ${mode ? styles.chipDark : ""}`}
            >
              <span className={styles.chipLabel}>{item.itemNo}</span>
              {item.warehouse && (
                <span className={styles.chipWarehouse}>{item.warehouse}</span>
              )}
              <button
                type="button"
                className={`${styles.chipRemove} ${mode ? styles.chipRemoveDark : ""}`}
                onClick={() => onRemove(item)}
                aria-label={`Remove ${item.itemNo}`}
              >
                ×
              </button>
            </span>
          ))}
        </div>
      )}

      {/* ── Search input ── */}
      <div className={styles.itemSearchWrapper}>
        <input
          disabled={!warehouseId}
          ref={inputRef}
          type="text"
          value={keyword}
          onChange={(e) => setKeyword(e.target.value)}
          onKeyDown={handleKey}
          placeholder={
            warehouseId
              ? "Search by item no or product name..."
              : "Select warehouse first"
          }
          className={`${styles.itemSearchInput} ${mode ? styles.inputDark : ""}`}
          autoComplete="off"
        />
        {loading && <span className={styles.itemSearchSpinner} />}

        {/* ── Table Dropdown ── */}
        {open && (
          <div
            className={`${styles.itemDropdown} ${mode ? styles.itemDropdownDark : ""}`}
          >
            {/* Table header */}
            <div
              className={`${styles.itemTableHeader} ${mode ? styles.itemTableHeaderDark : ""}`}
            >
              <span className={styles.colSno}>S.No</span>
              {/* <span className={styles.colThumb}></span> */}
              <span className={styles.colItemNo}>Item No</span>
              <span className={styles.colProduct}>Product</span>
              <span className={styles.colWarehouse}>Warehouse</span>
            </div>

            {/* One row per API entry — no grouping */}
            {results.map((item, idx) => {
              const alreadyAdded = selectedItems.some(
                (s) =>
                  s.itemNo === item.itemNo &&
                  s.warehouseId === item.warehouseId,
              );
              return (
                <div
                  key={`${item.itemNo}-${item.warehouseId}-${idx}`}
                  ref={(el) => (rowRefs.current[idx] = el)}
                  className={`
                    ${styles.itemTableRow}
                    ${mode ? styles.itemTableRowDark : ""}
                    ${idx === currentIndex ? styles.itemHighlighted : ""}
                    ${alreadyAdded ? styles.itemAlreadyAdded : ""}
                  `}
                  onMouseEnter={() => setCurrentIndex(idx)}
                  onClick={() => !alreadyAdded && handleSelect(item)}
                >
                  <span className={styles.colSno}>{idx + 1}</span>
                  {/* <span className={styles.colThumb}>
                    {item.thumbnail ? (
                      <img
                        src={`${process.env.REACT_APP_S3URLA + item.thumbnail}`}
                        alt=""
                        className={styles.itemThumb}
                        onError={(e) => {
                          e.target.style.display = "none";
                        }}
                      />
                    ) : (
                      <div
                        className={`${styles.itemThumbPlaceholder} ${mode ? styles.itemThumbPlaceholderDark : ""}`}
                      >
                        {item.itemNo.charAt(0)}
                      </div>
                    )}
                  </span> */}
                  <span
                    className={`${styles.colItemNo} ${styles.itemNoText} ${mode ? styles.itemNoTextDark : ""}`}
                  >
                    {item.itemNo}
                  </span>
                  <span
                    className={`${styles.colProduct} ${mode ? styles.colTextDark : ""}`}
                  >
                    {item.product_name || "—"}
                  </span>
                  <span
                    className={`${styles.colWarehouse} ${mode ? styles.colTextDark : ""}`}
                  >
                    {item.warehouse || "—"}
                  </span>

                  {alreadyAdded && (
                    <span className={styles.itemAddedBadge}>✓ Added</span>
                  )}
                </div>
              );
            })}
          </div>
        )}
      </div>

      <p className={`${styles.fieldHint} ${mode ? styles.fieldHintDark : ""}`}>
        ↑ ↓ navigate &nbsp;·&nbsp; Enter select &nbsp;·&nbsp; × to remove chip
      </p>
    </div>
  );
}

/* ─── Main Page ─────────────────────────────────────────────── */
const ManageProductionLine = () => {
  const { mode } = useAuth();
  const location = useLocation();

  const [Isstatus, setIsstatus] = useState("All");
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [showDrawer, setShowDrawer] = useState(false);
  const [selectedLine, setSelectedLine] = useState(null);
  const [form, setForm] = useState(EMPTY_FORM);
  const [warehouses, setWarehouses] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const [selectedWarehouse, setSelectedWarehouse] = useState("All");
  const [lines, setLines] = useState(STATIC_LINES);
  useEffect(() => {
    setWarehouses(
      warehousesData.map((w) => ({
        label: w.warehouse,
        value: w.warehouseId,
      })),
    );
  }, []);

  useEffect(() => {
    setSelectedItems([]);
  }, [form.warehouse]);

  const PAGE_SIZE = 24;

  const filtered = lines.filter((l) => {
    const matchStatus =
      Isstatus === "All" || l.status === Isstatus.toLowerCase();

    const matchWarehouse =
      selectedWarehouse === "All" || l.warehouseId === selectedWarehouse;

    const q = search.toLowerCase();

    const matchSearch =
      !q ||
      l.name.toLowerCase().includes(q) ||
      l.warehouse.toLowerCase().includes(q) ||
      l.designation.some((d) => d.toLowerCase().includes(q));

    return matchStatus && matchWarehouse && matchSearch;
  });

  const totalPages = Math.max(1, Math.ceil(filtered.length / PAGE_SIZE));
  const paginated = filtered.slice((page - 1) * PAGE_SIZE, page * PAGE_SIZE);

  const lineStatusData = STATUS_FILTERS.map((s) => ({
    statusText: s,
    statusItemCount:
      s === "All"
        ? lines.length
        : lines.filter((l) => l.status === s.toLowerCase()).length,
  }));

  const openCreate = () => {
    setSelectedLine(null);
    setForm(EMPTY_FORM);
    setSelectedItems([]);
    setShowDrawer(true);
  };

  const openEdit = (line) => {
    setSelectedLine(line);

    setSelectedItems(line.products || []);

    setForm({
      machineName: line.name,
      machineId: line.machineId || "",
      modelNo: line.designation[0] || "",
      warehouse: line.warehouseId,
      capacity: line.capacity,
      workingHour: line.workingHour,
      status: line.status.charAt(0).toUpperCase() + line.status.slice(1),
      autoAssign: true,
      pendingOnly: true,
    });

    setShowDrawer(true);
  };

  const handleFormChange = (field, value) =>
    setForm((prev) => ({ ...prev, [field]: value }));
  const handleStatusChange = (s) => {
    setIsstatus(s);
    setPage(1);
  };
  const handleAddItem = (item) => {
    setSelectedItems((prev) => {
      const exists = prev.some(
        (p) => p.itemNo === item.itemNo && p.warehouseId === item.warehouseId,
      );

      if (exists) return prev;

      return [...prev, item];
    });
  };
  const handleRemoveItem = (item) =>
    setSelectedItems((prev) =>
      prev.filter(
        (i) =>
          !(i.itemNo === item.itemNo && i.warehouseId === item.warehouseId),
      ),
    );

  const handleCreate = () => {
    const newLine = {
      id: Date.now(),
      name: form.machineName,
      designation: [form.modelNo],
      status: form.status.toLowerCase(),
      capacity: Number(form.capacity),
      workingHour: Number(form.workingHour),
      warehouse:
        warehousesData.find((w) => w.warehouseId === form.warehouse)
          ?.warehouse || "",
      warehouseId: form.warehouse,
      products: selectedItems,
    };

    setLines((prev) => [...prev, newLine]);

    setShowDrawer(false);
    setForm(EMPTY_FORM);
    setSelectedItems([]);
  };

  const handleUpdate = () => {
    setLines((prev) =>
      prev.map((line) =>
        line.id === selectedLine.id
          ? {
              ...line,
              name: form.machineName,
              designation: [form.modelNo],
              status: form.status.toLowerCase(),
              capacity: Number(form.capacity),
              workingHour: Number(form.workingHour),
              warehouse:
                warehousesData.find((w) => w.warehouseId === form.warehouse)
                  ?.warehouse || "",
              warehouseId: form.warehouse,
              products: selectedItems,
            }
          : line,
      ),
    );

    setShowDrawer(false);
  };

  // const handleDelete = (id) => {
  //   const confirmed = window.confirm("Delete this production line?");

  //   if (!confirmed) return;

  //   setLines((prev) => prev.filter((line) => line.id !== id));
  // };

  console.log("selectedItems", selectedItems);

  return (
    <>
      {/* ── Centered Modal ──────────────────────────────────── */}
      {showDrawer && (
        <div
          className={styles.modalOverlay}
          onClick={() => setShowDrawer(false)}
        >
          <div
            className={`${styles.centeredModal} ${mode ? styles.centeredModalDark : ""}`}
            onClick={(e) => e.stopPropagation()}
          >
            {/* Header */}
            <div className={styles.drawerHeader}>
              <h2>
                {selectedLine
                  ? "Update Production Line"
                  : "Add Production Line"}
              </h2>
              <button onClick={() => setShowDrawer(false)}>✕</button>
            </div>

            {/* Body */}
            <div className={styles.drawerBody}>
              {/* Row 1: Machine Name + Machine ID */}
              <div className={styles.formRow}>
                <div className={styles.formGroup}>
                  <label className={mode ? styles.labelDark : ""}>
                    Machine Name
                  </label>
                  <input
                    type="text"
                    value={form.machineName}
                    onChange={(e) =>
                      handleFormChange("machineName", e.target.value)
                    }
                    placeholder="e.g. Extruder 2"
                    className={mode ? styles.inputDark : ""}
                  />
                </div>
                <div className={styles.formGroup}>
                  <label className={mode ? styles.labelDark : ""}>
                    Machine ID
                  </label>
                  <input
                    type="text"
                    value={form.machineId}
                    onChange={(e) =>
                      handleFormChange("machineId", e.target.value)
                    }
                    placeholder="e.g. MCH-001"
                    className={mode ? styles.inputDark : ""}
                  />
                </div>
              </div>

              {/* Row 2: Warehouse + Model No */}
              <div className={styles.formRow}>
                <div className={styles.formGroup}>
                  <label className={mode ? styles.labelDark : ""}>
                    Warehouse
                  </label>

                  <select
                    value={form.warehouse}
                    onChange={(e) =>
                      handleFormChange("warehouse", e.target.value)
                    }
                    className={mode ? styles.inputDark : ""}
                  >
                    <option value="">Select Warehouse</option>
                    {warehouses.map((w) => (
                      <option key={w.value} value={w.value}>
                        {w.label}
                      </option>
                    ))}
                  </select>
                </div>
                <div className={styles.formGroup}>
                  <label className={mode ? styles.labelDark : ""}>
                    Model No
                  </label>
                  <input
                    type="text"
                    value={form.modelNo}
                    onChange={(e) =>
                      handleFormChange("modelNo", e.target.value)
                    }
                    placeholder="e.g. WALLIKON-X2"
                    className={mode ? styles.inputDark : ""}
                  />
                </div>
              </div>

              {/* Row 3: Capacity + Working Hours */}
              <div className={styles.formRow}>
                <div className={styles.formGroup}>
                  <label className={mode ? styles.labelDark : ""}>
                    Capacity (pcs/day)
                  </label>
                  <input
                    type="number"
                    value={form.capacity}
                    onChange={(e) =>
                      handleFormChange("capacity", e.target.value)
                    }
                    placeholder="600"
                    className={mode ? styles.inputDark : ""}
                  />
                </div>
                <div className={styles.formGroup}>
                  <label className={mode ? styles.labelDark : ""}>
                    Working Hours / Day
                  </label>
                  <input
                    type="number"
                    value={form.workingHour}
                    onChange={(e) =>
                      handleFormChange("workingHour", e.target.value)
                    }
                    placeholder="8"
                    className={mode ? styles.inputDark : ""}
                  />
                </div>
              </div>

              {/* Status */}
              <div className={styles.formGroup}>
                <label className={mode ? styles.labelDark : ""}>Status</label>
                <select
                  value={form.status}
                  onChange={(e) => handleFormChange("status", e.target.value)}
                  className={mode ? styles.inputDark : ""}
                >
                  <option>Running</option>
                  <option>Idle</option>
                  <option>Maintenance</option>
                  <option>Stopped</option>
                </select>
              </div>

              {/* Item Chip Search */}
              <ItemChipSearch
                mode={mode}
                selectedItems={selectedItems}
                onAdd={handleAddItem}
                onRemove={handleRemoveItem}
                warehouseId={form.warehouse}
              />

              {/* Settings */}
              <div
                className={`${styles.settingsBox} ${mode ? styles.settingsBoxDark : ""}`}
              >
                <p
                  className={`${styles.settingsTitle} ${mode ? styles.settingsTitleDark : ""}`}
                >
                  Settings
                </p>
                <div className={styles.settingRow}>
                  <span
                    className={`${styles.settingLabel} ${mode ? styles.settingLabelDark : ""}`}
                  >
                    Auto-assign selected products to this line
                  </span>
                  <label className={styles.toggle}>
                    <input
                      type="checkbox"
                      checked={form.autoAssign}
                      onChange={(e) =>
                        handleFormChange("autoAssign", e.target.checked)
                      }
                    />
                    <span className={styles.toggleSlider} />
                  </label>
                </div>
              </div>
            </div>

            {/* Footer */}
            <div
              className={`${styles.drawerFooter} ${mode ? styles.drawerFooterDark : ""}`}
            >
              <Button
                buttonTextColor={"#ffffff"}
                buttonBgColor={"#000000"}
                buttonClick={() => setShowDrawer(false)}
                buttonText={"Cancel"}
              />
              <Button
                buttonTextColor={"#ffffff"}
                buttonBgColor={"#4164E3"}
                buttonText={selectedLine ? "Update Line" : "Create Line"}
                buttonClick={() => {
                  if (selectedLine) {
                    handleUpdate();
                  } else {
                    handleCreate();
                  }
                }}
              />
            </div>
          </div>
        </div>
      )}

      {/* ── Page Shell ─────────────────────────────────────── */}
      <div
        className={styles.mgx}
        style={
          mode ? { backgroundColor: "#2C2E33", borderColor: "#2C2E33" } : {}
        }
      >
        <div className={styles.mgx_top}>
          <TopTabBar text={location.pathname.slice(1)} />
          <div className={styles.mgx_top_right}>
            <Button
              buttonIcon={<TestTopAddDealerIcon />}
              buttonText={"Add Line"}
              buttonBgColor={"#4164E3"}
              buttonTextColor={"#ffffff"}
              buttonBorder={"none"}
              buttonClick={openCreate}
            />
          </div>
        </div>

        <div
          className={styles.mgx_middle}
          style={
            mode ? { backgroundColor: "#232529", borderColor: "#232529" } : {}
          }
        >
          {lineStatusData.map((status) => (
            <div
              key={status.statusText}
              className={`${styles.receipts_filter} ${mode ? styles.receipts_filter_dark : ""} ${status.statusText === Isstatus ? (mode ? styles.receipts_filter_active_dark : styles.receipts_filter_active) : ""}`}
              onClick={() => handleStatusChange(status.statusText)}
            >
              <DealerStatusCard
                statusText={status.statusText}
                statusItemCount={status.statusItemCount}
              />
            </div>
          ))}
        </div>

        <div
          className={styles.mgx_bottom}
          style={mode ? { backgroundColor: "#2C2E33" } : {}}
        >
          <div className={styles.mgx_top} style={{ marginBottom: "10px" }}>
            <SearchBar
              padding={"6px"}
              fontSize={"12px"}
              fontWeight={"400"}
              borderRadius={"5px"}
              placeholder={"Search Production Lines"}
              onChange={(e) => {
                setSearch(e.target.value);
                setPage(1);
              }}
            />
            <div className={styles.mgx_top_right}>
              <DropDown
                label={"Warehouse"}
                listLabel={"All"}
                options={[{ label: "All", value: "All" }, ...warehouses]}
                onSelect={(option) => {
                  setSelectedWarehouse(option.value);
                  setPage(1);
                }}
              />
            </div>
          </div>

          {paginated.length === 0 ? (
            <div
              style={{
                flex: 1,
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <NoDataFound
                icon={<TemplateNotFound />}
                to={"/production/line"}
              />
              <p style={{ color: mode ? "#ffffff" : "#000000" }}>
                No Data Found
              </p>
            </div>
          ) : (
            <div className={styles.maindivscroll}>
              <div
                className={styles.mgx_data}
                style={mode ? { backgroundColor: "#2C2E33" } : {}}
              >
                {paginated.map((line) => (
                  <div
                    className={styles.mgx_card}
                    key={line.id}
                    onClick={() => openEdit(line)}
                  >
                    <ProdLineInfoCard
                      lineName={line.name}
                      lineStatus={line.status}
                      manufacturer={line.designation[0]}
                      subText={line.designation.slice(1).join(", ")}
                      capacity={line.capacity}
                      workingHour={line.workingHour}
                      warehouse={line.warehouse}
                      warehouseId={line.warehouseId}
                    />
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>

        <div
          className={styles.mgx_pagination}
          style={{ backgroundColor: mode ? "#232529" : "#fff" }}
        >
          <div style={{ width: "50%" }}>
            <div
              style={{
                width: "50%",
                display: "flex",
                justifyContent: "flex-start",
                fontSize: "14px",
              }}
            >
              <GoToPage
                currentPage={page}
                setCurrentPage={(n) => setPage(n)}
                totalPages={totalPages}
                key="goto"
              />
            </div>
          </div>
          <div
            style={{
              width: "50%",
              display: "flex",
              justifyContent: "flex-end",
              fontSize: "12px",
            }}
          >
            <Pagenation
              currentPage={page}
              setCurrentPage={(n) => setPage(n)}
              totalPages={totalPages}
              key="page"
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default ManageProductionLine;
